import React from 'react'
import { PaymentMethod } from '../PaymentComponent/PaymentMethod'

export const Payment = () => {
  return (
    <>
    <PaymentMethod/>
    </>
  )
}